import React from 'react';
import { t } from '../../services/i18nService';
import aclService from '../../services/AclService';
import navigationService from '../../services/NavigationService';
import resultReader from './../../store/readHelpers/ResultReader';
import sessionReader from '../../store/readHelpers/SessionReader';

import styles from './header.scss';

class ResultSubHeader extends React.Component {
    componentDidMount() {
        this.h1.focus();
    }

    getScoreTotals() {
        return aclService.canSeeScore() ? resultReader.getScoreTotalsAsStrings() : undefined;
    }

    render() {
        const scoreTotals = this.getScoreTotals();

        return (
            <div className={styles.tocHeaderWrapper}>
                <div className={styles.statusSection}>
                    <div className={styles.subHeaderTitle}>
                        <h1 tabIndex="-1" ref={(h1) => { this.h1 = h1; }}>{t('result.resultPageHeader')}</h1>
                        {
                            scoreTotals ?
                                <p>{t('result.totalMarksSubHeader', {
                                    score: scoreTotals.totalScore,
                                    maxScore: scoreTotals.maxTotalScore,
                                })}</p>
                                :
                                null
                        }
                    </div>

                    <div className={styles.rightSide}>
                        <div className={styles.buttons}>
                            {
                                sessionReader.isContextExam() ?
                                    <button
                                        id="btnBackToDashboard"
                                        className="btn"
                                        onClick={navigationService.navigateToDashboardTicket}
                                    >
                                        {t('result.btnBackToDashboard')}
                                    </button> : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ResultSubHeader;
